define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dijit/form/Button",
	"csi/_base/underscore",
	"./_Plugin",
	"./util"
], function(array,declare,Button,_,_Plugin,util) {

	return declare([Button, _Plugin], {
		bHorizontal: false,
		degrees: 0,

		enablePlugin: function(/*Shape[]*/shapes, /*Object*/shapeAttrs, /*Object*/textAttrs) {
			// summary: only enable if selected shape(s)
			return !!shapes && this.editor.isDefaultCanvasMode() && this.inherited(arguments);
		},

		onClick: function() {
			if (this.degrees != 0) {
				this.editor.canvasApp.pageApi().rotateObjects(this.degrees);
			} else {
				var flipOptions = {flipH:this.bHorizontal, flipV: !this.bHorizontal};
				this.editor.canvasApp.pageApi().flipObjects(flipOptions);
			}
		}
	});
});
